import { SECTORS, SECTORS_HEAD } from "@/data/content";
import { Reveal, SectionHead } from "@/components/Reveal";

export default function Sectors() {
  return (
    <section id="sectors" data-testid="sectors-section" className="section-pad bg-mist">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHead eyebrow={SECTORS_HEAD.eyebrow} title={SECTORS_HEAD.title} />

        <div className="mt-8 hairline-t border-line md:mt-12">
          {SECTORS.map((s, i) => (
            <Reveal key={s.id} delay={i * 0.05}>
              <div className="hairline-b border-line py-7" data-testid={`sector-row-${s.id}`}>
                <div className="flex items-baseline gap-4">
                  <span
                    className="font-display text-sector-sm font-medium text-accent/40 md:text-sector"
                    aria-hidden="true"
                  >
                    {i + 1}
                  </span>
                  <h3 className="font-display text-sector-sm font-medium text-ink md:text-sector">
                    {s.name}
                  </h3>
                </div>
                <div className="mt-3.5 flex flex-wrap gap-2">
                  {s.topics.map((t) => (
                    <span
                      key={t}
                      className="hairline rounded-full border-line bg-paper px-3 py-1 text-tag text-accent"
                    >
                      {t}
                    </span>
                  ))}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
